export const AUTH_ACTION_TYPES = Object.freeze({
  SET_USER: 'auth/SET_USER',
  CLEAR_AUTH: 'auth/CLEAR_AUTH',
  SET_AUTH_LOADING: 'auth/SET_AUTH_LOADING',
  SET_AUTH_ERROR: 'auth/SET_AUTH_ERROR',
  CLEAR_AUTH_ERROR: 'auth/CLEAR_AUTH_ERROR',
  SET_BOOTSTRAPPED: 'auth/SET_BOOTSTRAPPED',
});

export const initialAuthState = Object.freeze({
  user: null,
  isAuthenticated: false,
  loading: false,
  error: null,
  bootstrapped: false,
});

export default function authReducer(state = initialAuthState, action) {
  if (!action || typeof action !== 'object') return state;

  switch (action.type) {
    case AUTH_ACTION_TYPES.SET_USER: {
      const user = action.payload && action.payload.user !== undefined
        ? action.payload.user
        : action.payload;
      return {
        ...state,
        user: user || null,
        isAuthenticated: Boolean(user),
        loading: false,
        error: null,
      };
    }
    case AUTH_ACTION_TYPES.CLEAR_AUTH:
      return {
        ...initialAuthState,
        bootstrapped: state.bootstrapped,
      };
    case AUTH_ACTION_TYPES.SET_AUTH_LOADING:
      return {
        ...state,
        loading: Boolean(action.payload && action.payload.loading !== undefined
          ? action.payload.loading
          : action.payload),
      };
    case AUTH_ACTION_TYPES.SET_AUTH_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload && action.payload.error
          ? String(action.payload.error)
          : (action.payload ? String(action.payload) : null),
      };
    case AUTH_ACTION_TYPES.CLEAR_AUTH_ERROR:
      return { ...state, error: null };
    case AUTH_ACTION_TYPES.SET_BOOTSTRAPPED:
      return {
        ...state,
        bootstrapped: true,
        loading: false,
      };
    default:
      return state;
  }
}
